import React from 'react';
import PropTypes from 'prop-types';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ListPlaceTips.css';
import { Grid, Row, Col } from 'react-bootstrap';
import FontAwesome from 'react-icons/fa';
import cx from 'classnames';

// Translation
import { Text, Whitespace } from '../../components_new/common';

class ListPlaceTips extends React.Component {
  static propTypes = {};

  render() {
    const { tips } = this.props;
    return (
      <Col xs={12} sm={12} md={4} lg={4} xsHidden smHidden>
        <div className={s.helpPanelContainer}>
          <div className={s.helpPanel}>
            <div className={s.helpPanelText}>
              <Text bold primary header inline>
                Tips
              </Text>
              <Whitespace small />
              {tips &&
                tips.map((tipCategory, i) => (
                  <div key={i}>
                    <Text large>{tipCategory.title}</Text>
                    <ul className="pl-mxxx">
                      {tipCategory.tips.map(tip => (
                        <li key={tip}>{tip}</li>
                      ))}
                    </ul>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </Col>
    );
  }
}

export default withStyles(s)(ListPlaceTips);



// WEBPACK FOOTER //
// ./src/components/ListPlaceTips/ListPlaceTips.js